import React from 'react';
import PropTypes from 'prop-types';
import styles from './ImageGrid.module.scss';
import LazyImage from '../LazyImage/LazyImage';

const ImageGrid = ({ images, className }) => {
    // Dynamische Spaltenklassen basierend auf der Anzahl der Bilder
    const getColClass = (imageCount) => {
        switch (imageCount) {
            case 0:
            case 1:
                return "col-12";
            case 2:
            case 3:
            case 4:
                return "col-6";
            case 5:
            case 6:
            case 7:
            case 8:
                return "col-4";
            case 9:
                return "col-4";
            default:
                return "col-3";
        }
    };

    // Spezialfall: Nur ein Bild
    if (images.length === 1) {
        return (
            <div className={`${styles.ImageGrid} ${className || ''}`}>
                <div className="row g-3">
                    <div className="col-12">
                        <LazyImage
                            src={images[0].mediaUrl}
                            fill_mode="cover"
                            round
                            alt={images[0].alt_text}
                            className={`img-fluid w-100 ${styles.singleImage}`}
                        />
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className={`${styles.ImageGrid} ${className || ''}`}>
            <div className="row g-3">
                {images.map((img, index) => (
                    <div key={index} className={getColClass(images.length)}>
                        <LazyImage
                            src={img.mediaUrl}
                            ratio="1x1"
                            fill_mode="cover"
                            round
                            alt={img.alt_text}
                            className={`img-fluid object-fit-cover ${styles.gridImage}`}
                        />
                    </div>
                ))}
            </div>
        </div>
    );
};

ImageGrid.propTypes = {
    images: PropTypes.arrayOf(
        PropTypes.shape({
            mediaUrl: PropTypes.string.isRequired,
            alt_text: PropTypes.string,
        })
    ).isRequired,
    className: PropTypes.string,
};

export default ImageGrid;
